<template>
  <v-dialog
    v-model="show"
    max-width="400"
    persistent
    content-class="growth_vitamin_dialog"
  >
    <div class="white">
      <v-card v-if="data.DiscountInfo != null" class="body__background-color">
        <!-- Image -->
        <v-row class="ma-0 py-3 px-3" justify="center">
          <v-img
            v-if="data.DiscountInfo.Type !== 'Tip'"
            :src="getGrowthVitaminImage(data.DiscountInfo.Type)"
            max-width="95px"
          />
          <v-avatar
            v-else-if="getMainPartnerSecondaryPicture() !== ''"
            size="100"
          >
            <v-img
              :src="getGrowthVitaminImage(data.DiscountInfo.Type)"
              max-width="100px"
              max-height="100px"
            />
          </v-avatar>
          <v-img
            v-else
            :src="getGrowthVitaminImage(data.DiscountInfo.Type)"
            max-width="100px"
            max-height="100px"
            contain
          />
        </v-row>

        <!-- Title -->
        <h3
          class="text-break text-center px-3"
          :class="
            data.DiscountInfo.Type === 'Fixed Discount' ? 'red--text' : ''
          "
          style="line-height: 1.3"
        >
          {{
            data.DiscountInfo.Type === 'Fixed Discount'
              ? `${formatter.format(data.DiscountInfo.DiscountFixedValue)}
                       ${$translate('DISCOUNT')}`
              : data.Name
          }}
        </h3>

        <v-card-text>
          <div v-html="data.Description" class="mb-3" />

          <div
            v-if="data.DiscountInfo != null && data.DiscountInfo.Type !== 'Tip'"
          >
            * {{ $translate('AVAILABLE_UNTIL') }}
            {{ returnCorrectTimeFormat(data.ExpiryUnixTime) }}
          </div>
        </v-card-text>

        <Suggestions
          v-if="
            data.DiscountInfo != null &&
            data.DiscountInfo.Products != null &&
            data.DiscountInfo.Products.length > 0
          "
          :suggestions="data.DiscountInfo.Products"
          :cols="7"
          :sm="6"
          :md="5"
          :lg="4"
          :mdWrap="false"
          :showInSale="true"
          :globalLabel="
            data.DiscountInfo.Type === 'Percentage Discount'
              ? `-${data.DiscountInfo.DiscountPercentage}%`
              : ''
          "
          :globalDiscountPercentage="data.DiscountInfo.DiscountPercentage"
          class="px-3"
          @click="goToProduct"
        />
        <Suggestions
          v-if="
            data.DiscountInfo != null &&
            data.DiscountInfo.Events != null &&
            data.DiscountInfo.Events.length > 0
          "
          :suggestions="data.DiscountInfo.Events"
          :cols="7"
          :sm="6"
          :md="5"
          :lg="4"
          :mdWrap="false"
          :showInSale="false"
          :globalLabel="
            data.DiscountInfo.Type === 'Percentage Discount'
              ? `-${data.DiscountInfo.DiscountPercentage}%`
              : ''
          "
          :globalDiscountPercentage="data.DiscountInfo.DiscountPercentage"
          class="px-3"
          @click="goToEvent"
        />
        <Suggestions
          v-if="
            data.DiscountInfo != null &&
            data.DiscountInfo.ProductCategories != null &&
            data.DiscountInfo.ProductCategories.length > 0
          "
          :suggestions="data.DiscountInfo.ProductCategories"
          :cols="7"
          :sm="6"
          :md="5"
          :lg="4"
          :mdWrap="false"
          :showInSale="false"
          :globalLabel="
            data.DiscountInfo.Type === 'Percentage Discount'
              ? `-${data.DiscountInfo.DiscountPercentage}%`
              : ''
          "
          :globalDiscountPercentage="data.DiscountInfo.DiscountPercentage"
          class="px-3"
          @click="goToProduct"
        />

        <v-card-actions>
          <v-spacer />
          <v-btn class="success ma-3" text @click="show = false">
            {{ $translate('CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Suggestions from '@/components/generalComponents/Suggestions';
import { addLog } from '@/api/dssRequest';
import utility from '@/shared/utility';

export default {
  data() {
    return {
      show: false,
      data: {},
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  components: {
    Suggestions,
  },
  created() {
    window.EventBus.listen('activateGrowthDialog', this.activateGrowthDialog);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      'activateGrowthDialog',
      this.activateGrowthDialog
    );
  },
  methods: {
    returnCorrectTimeFormat(unixTimestamp) {
      return utility.unixTimeToDateTimeString(unixTimestamp);
    },
    getGrowthVitaminImage(type) {
      switch (type) {
        case 'Fixed Discount':
        case 'Percentage Discount':
          return require('@/assets/growthVitaminIcons/discount.png');
        case 'Credits':
          return require('@/assets/growthVitaminIcons/credit.png');
        case 'Free Delivery':
          return require('@/assets/growthVitaminIcons/delivery.png');
        case 'Voucher':
          return require('@/assets/growthVitaminIcons/gift.png');
        case 'Tip':
          return this.getTipImage();
        default:
          return require('@/assets/growthVitaminIcons/discount.png');
      }
    },
    getTipImage() {
      const partnerGroupDetails =
        this.$store.getters['Account/partnerGroupDetails'];

      let secondaryPictureUrl = this.getMainPartnerSecondaryPicture();
      if (secondaryPictureUrl === '') return partnerGroupDetails.Logo;

      return secondaryPictureUrl;
    },
    getMainPartnerSecondaryPicture() {
      const partnerGroupDetails =
        this.$store.getters['Account/partnerGroupDetails'];
      if (partnerGroupDetails == null || partnerGroupDetails.Partners == null) {
        return '';
      }

      const mainPartner = partnerGroupDetails.Partners.find(
        (partner) => partner.MainPartner
      );

      if (mainPartner == null) return '';

      return mainPartner.SecondaryPictureUrl;
    },
    activateGrowthDialog(growthVitaminObject) {
      this.data = growthVitaminObject;
      this.show = true;
    },
    goToProduct(product) {
      this.$store.commit('event/setCurrentWatchedProduct', product);

      if (product != null && product.MetaData != null) {
        window.EventBus.fire('updateMetaData', product.MetaData);
      }
      this.show = false;

      addLog(
        this.$store.getters['auth/userObjectId'],
        product.Id,
        'Product',
        'ProductDetails',
        -1
      );
      // route to the product details
      this.$router.push({
        name: 'ProductWithoutCategory',
        params: { event_id: product.EventId, product_id: product.Id },
      });
    },
    goToEvent(event){
      this.show = false;

      addLog(
        this.$store.getters['auth/userObjectId'],
        event.Id,
        'Event',
        'EventDetails',
        -1
      );
      this.$router.push({
        name: 'EventDetails',
        params: { event_id: product.EventId},
      });
    },
    goToProductCategory(category){
      addLog(
        this.$store.getters['auth/userObjectId'],
        category.Id,
        'Event',
        'EventDetails',
        -1
      );
      this.getCategoryDetails();
    },
    getCategoryDetails(productCategory) {
      const payload = {
        ProductCategoryId: productCategory.ObjectId,
      };
      const object = this.userObjectId;
      doRequest(
        (response) => {
          const category = response.data;
          // route to eventDetails
          this.goToPage('ProductCategory', {
            event_id: category.ProductCategory.EventId,
            category_id: productCategory.ObjectId,
          });
        },
        () => {},
        'getProductsByCategory',
        object,
        payload,
        'GET'
      );
    },
  },
};
</script>

<style scoped>
 .growth_vitamin_dialog {
  position: absolute;
  bottom: 0px;
  right: 0px;
}
</style>
